import { marked } from "marked";

// Posts written via the HTML toolbar contain block-level tags; posts pasted
// as Markdown (or plain text) don't. Render the latter through marked so
// headings/bold/lists display properly instead of raw ## and ** characters.
const BLOCK_HTML =
  /<\/?(p|div|h[1-6]|ul|ol|li|table|thead|tbody|tr|td|th|blockquote|img|iframe|figure|section|article|pre|br|hr)\b/i;

export function renderPostContent(raw: string | null | undefined): string {
  if (!raw) return "";
  if (BLOCK_HTML.test(raw)) return raw;
  return marked.parse(raw, { async: false }) as string;
}
